import React from 'react';
import './ListTools.css';

export const TICKET_STATUSES = ['Open', 'In Progress', 'On Hold', 'Awaiting Approval',
                                'Resolved', 'Approved', 'Closed'];

const slug = (v) => String(v || '').trim().toLowerCase().replace(/\s+/g, '-');

/**
 * The ticket status, said loudly.
 *
 * Gordon: "show and highlight status of the tickets" - on My tickets, then on
 * Work & time and Issued Bills, which printed no ticket status at all. One
 * badge for all three so a status looks the same wherever it appears. The
 * colours are App.css's .ticket-status-badge, which the staff lists already
 * use; `is-loud` adds the dot and the edge.
 */
export function StatusBadge({ status }) {
  if (!status) return <span className="lt-none">—</span>;
  return (
    <span className="ticket-status-badge is-loud" data-status={slug(status)}>
      {status}
    </span>
  );
}

/**
 * A sort select and a ticket-status filter, the same on every contractor list.
 *
 * `sorts` is [{ key, label }]; `statuses` is the set actually present in the
 * list, so the filter offers only what it can find. Everything else about the
 * list - what the sort keys mean, how a status is read off a row - belongs to
 * the caller, which is why this holds no state of its own.
 */
export function ListTools({
  sortBy, onSort, sorts,
  status, onStatus, statuses = TICKET_STATUSES,
  query, onQuery, placeholder = 'Find…',
  onClear, children
}) {
  const narrowed = (status && status !== 'all') || Boolean(query);
  return (
    <div className="lt" role="group" aria-label="Sort and filter">
      {sorts && (
        <label className="lt-tool">
          <span>Sort</span>
          <select value={sortBy} onChange={(e) => onSort(e.target.value)}>
            {sorts.map((s) => <option key={s.key} value={s.key}>{s.label}</option>)}
          </select>
        </label>
      )}
      {onStatus && (
        <label className="lt-tool">
          <span>Status</span>
          <select value={status} onChange={(e) => onStatus(e.target.value)}>
            <option value="all">All</option>
            {statuses.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </label>
      )}
      {onQuery && (
        <label className="lt-tool lt-grow">
          <span>Find</span>
          <input type="search" value={query} placeholder={placeholder}
                 aria-label={placeholder}
                 onChange={(e) => onQuery(e.target.value)} />
        </label>
      )}
      {children}
      {narrowed && onClear && (
        <button type="button" className="lt-clear" onClick={onClear}>Clear</button>
      )}
    </div>
  );
}

export default ListTools;
